import React from 'react'

export const ToAgreeCheck = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="56" fill="none" viewBox="0 0 49 56">
      <path
        fill="#32D74B"
        fillRule="evenodd"
        d="M34.49 28.511a1.751 1.751 0 010 2.478l-10.5 10.5a1.751 1.751 0 01-2.479 0l-5.25-5.25a1.754 1.754 0 010-2.478 1.752 1.752 0 012.478 0l4.011 4.014 9.261-9.264a1.748 1.748 0 012.478 0z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#32D74B"
        d="M24.5 3.5a8.75 8.75 0 018.75 8.75V14h-17.5v-1.75A8.75 8.75 0 0124.5 3.5zM36.75 14v-1.75a12.25 12.25 0 10-24.5 0V14H0v35a7 7 0 007 7h35a7 7 0 007-7V14H36.75zM3.5 17.5h42V49a3.5 3.5 0 01-3.5 3.5H7A3.5 3.5 0 013.5 49V17.5z"
      ></path>
    </svg>
  )
}
